import { render, staticRenderFns } from "./InsButton.vue?vue&type=template&id=651f6890&scoped=true"
import script from "./InsButton.vue?vue&type=script&lang=ts"
export * from "./InsButton.vue?vue&type=script&lang=ts"
import style0 from "./InsButton.vue?vue&type=style&index=0&id=651f6890&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f6890",
  null
  
)

export default component.exports